"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = bare;

var _get = _interopRequireDefault(require("./get"));

var _set = _interopRequireDefault(require("./set"));

var _verify = _interopRequireDefault(require("./verify"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function bare(config) {
  (0, _verify.default)(config);
  return Object.assign({}, config, {
    get(path) {
      return (0, _get.default)(this, path);
    },

    set(path, value) {
      return (0, _set.default)(this, path, value);
    },

    pure() {
      const o = Object.assign({}, this);
      delete o.get;
      delete o.set;
      delete o.pure;
      return o;
    }

  });
}